import CommonRouter from './CommonRouter'
import { socialRoutes } from '../routes/SocialRoutes'
const CurrentNavigator = CommonRouter('MyProfile', socialRoutes.Profile)
export default CurrentNavigator
